import React, { useState, useEffect, useMemo } from "react";
import { useTable, useGlobalFilter } from 'react-table';
import axios from "axios";
import { AgGridReact } from 'ag-grid-react';
import { Modal } from "semantic-ui-react";
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import DynamicForm from '../common/DynamicForm';
import LoaderComponent from "../../../libraries/loader/loader";
import { Fetchexecutequery, Fetchheaderdata, Fetchupdatequery,servePdf } from '../../../services/process/BRS1/brsService7';
import { CreateData } from '../../../services/process/process_data/process_data';
import { Icon,Grid } from 'semantic-ui-react';
import '../css/reconSummary.css';
import Select from "react-select";
import EditIcon from '@mui/icons-material/Edit';
import excelIcon from '../../../assets/images/excel.png';
import FileViewer from "react-file-viewer";
import FilePreviewer from "../common/file_displayer";
import SearchInput from "../common/search_input";


function PurchaseRequirement() {
  const [formData, setFormData] = useState({});
  const [userCredentials] = useState(JSON.parse(sessionStorage.getItem("userCredentials")));

  const [filterconditions,setFilterconditions] =  useState([{"is_active" : 1,"entity_id" : userCredentials.selectedentity,"tenant_id": userCredentials.tenants_id,"group_id": userCredentials.groups_id}]);
  const [formData1, setFormData1] = useState({});
  const [formData2, setFormData2] = useState({});
  const [formData3, setFormData3] = useState({});
  const [rowData, setRowData] = useState([]);
  const [tablerowData, settableRowData] = useState([]);
  const [fields, setFields] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [columnDefs, setColumnDefs] = useState([]);
  const [tablecolumnDefs, settableColumnDefs] = useState([]);
  const [tablecolumnDefs1, settableColumnDefs1] = useState([]);
  const [fields1, setFields1] = useState(null);
  const [columnDefs1, setColumnDefs1] = useState([]);
  const [fields2, setFields2] = useState(null);
  const [columnDefs2, setColumnDefs2] = useState([]);
  const [fields3, setFields3] = useState(null);
  const [columnDefs3, setColumnDefs3] = useState([]);
  const [fields4, setFields4] = useState(null);
  const [columnDefs4, setColumnDefs4] = useState([]);
  const [prfno, setPrfno] = useState('');
  const [manager, setManager] = useState('');
  const [section2Rows, setSection2Rows] = useState([{}]);
  const [section3Rows, setSection3Rows] = useState([{}]);
  const [unMatchedHidden, setUnMatchedHidden] = useState(false);
  const [selectedFile, setSelectedFile] = useState('');
  const [fileType, setFileType] = useState('');
  const [createHidden, setCreateHidden] = useState(true);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [editMode, setEditMode] = useState(false); // State to track if in edit mode
  const [quotations, setQuotations] = useState([{ id: 1, label: "Quotation 1" }]);
  const [selectedQuotationId, setSelectedQuotation] = useState(0);
  const [quotationData, setQuotationData] = useState([]);
  const [options, setOptions] = useState([]);
  const [quotationinputData, setQuotationinputData] = useState([]);
  const [selectedvalue, setSelectedvalue] = useState('');
  const [selectedRow, setSelectedRow] = useState(null);
  const baseUrl = "http://206.1.17.185:1201/static/";
  const [numPages, setNumPages] = useState(null);
  const [gridApi, setGridApi] = useState(null);
  const [showDetails, setShowDetails] = useState(false);


  // State to control collapsibility of divs
  const [isDiv1Open, setIsDiv1Open] = useState(true);
  const [isDiv2Open, setIsDiv2Open] = useState(true);
  const [isDiv3Open, setIsDiv3Open] = useState(true);
  const [isDiv4Open, setIsDiv4Open] = useState(true);

  function handleSelection(event) {
    console.log("event",event,event.value)
    const selectedValue = event;
    setSelectedvalue(selectedValue);
    const filePath = event.value;
    setSelectedFile(filePath);
    if (filePath) {
      const fileExtension = filePath.split('.').pop().toLowerCase(); // Get file extension

      // Determine the file type
      if (fileExtension === 'pdf') {
        setFileType('pdf');
      } else if (['jpg', 'jpeg', 'png'].includes(fileExtension)) {
        setFileType('image');
      } else {
        setFileType('');
      }
    } else {
      setFileType('');
    }
};

const MyFilePreview1 = ({ fileType, filePath }) => {
  return (
    <div style={{ width: "100%", height: "600px" }}>
      <FileViewer
        fileType={fileType}   // e.g. "pdf", "png", "jpg"
        filePath={filePath}   // full URL or path to the file
      />
    </div>
  );
};


const deleteAttachments = async () => {
  try {
    if (!selectedvalue?.id) {
      alert("Please select a row first.");
      return;
    }

    const confirmed = window.confirm(
      "Are you sure you want to delete this attachment?"
    );

    if (!confirmed) {
      return; // User clicked Cancel
    }

    const payload_invoice = {
      schema_name: "payments",
      table: "adhoc_invoice_details",
      set_column: [
        { is_active: 0 }
      ],
      where: [
        { id: selectedvalue.id }
      ]
    };

    const FileUploadCredentials_3 = Fetchupdatequery();

    await axios.post(
      FileUploadCredentials_3[1],
      payload_invoice,
      FileUploadCredentials_3[0]
    );

    console.log("adhoc_invoice_details updated successfully");
    alert("Attachment deleted successfully.");
  } catch (error) {
    console.error("Failed to update adhoc_invoice_details", error);
    alert("Failed to delete attachment. Please try again.");
  }
};




const handleGridSearch = (searchValue) => {
  if (gridApi) {
    gridApi.setQuickFilter(searchValue); // AG Grid quick filter
  }
};

  const handleDetailsClick = () => {
    if (!selectedRow) {
      alert("Please select a row first.");
      return;
    }
    setShowDetails(true);
  };

  const closeModal = () => {
    setShowDetails(false);
  };


const MyFilePreview = ({ fileType, filePath }) => {
  const [url, setUrl] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!filePath) return;

    const fetchPdf = async () => {
      try {
        const payload = { filePath };
        const response = await axios.post(
          "http://206.1.17.185:1200/api/v2/user_modules/serve-pdf/",
          payload,
          {
            headers: { "Content-Type": "application/json" },
            responseType: "blob",
          }
        );

        const blob = new Blob([response.data], { type: "application/pdf" });
        setUrl(URL.createObjectURL(blob));
      } catch (err) {
        setError("Error loading file");
      }
    };

    fetchPdf();
  }, [filePath]);

  if (error) return <div style={{ color: "red" }}>{error}</div>;
  if (!url) return <div>Loading...</div>;

  return (
    <div style={{ width: "100%", height: "600px" }}>
      <FileViewer fileType={fileType} filePath={url} />
    </div>
  );
};

  useEffect(() => {
    fetchFieldInfo(2, setFields, setColumnDefs);
    fetchprfTableInfo1();
    fetchprfTableInfo2();
    fetchtabledetailsInfo();
    BrsTypeList();
  }, []);

const getFileDataRequired = (responseData) => {
    const dataValues = responseData;
    const requiredFileData = {};

    for (const key in dataValues) {
      if (key.startsWith("file_") && key.endsWith("_type")) {
        const fileTypeValue = dataValues[key];
        const fileIndex = key.split("_")[1]; // Extract the index (e.g., '1' from 'file_1_type')
        if (fileTypeValue.length > 0) {
          const filePath = dataValues[`file_${fileIndex}_path`];
          requiredFileData[`file_${fileIndex}`] = {
            type: fileTypeValue,
            path: filePath,
          };
        }
      }
    }

    return requiredFileData;
  };


  function BrsTypeList() {
  const formatted = userCredentials.department.join(",");
  let payload = {
    query: `SELECT id,
      IFNULL(TRIM(file_1_type), '') AS 'file_1_type',
      IFNULL(TRIM(file_1_path), '') AS 'file_1_path',
      IFNULL(TRIM(file_2_type), '') AS 'file_2_type',
      IFNULL(TRIM(file_2_path), '') AS 'file_2_path',
      IFNULL(TRIM(file_3_type), '') AS 'file_3_type',
      IFNULL(TRIM(file_3_path), '') AS 'file_3_path',
      IFNULL(TRIM(file_4_type), '') AS 'file_4_type',
      IFNULL(TRIM(file_4_path), '') AS 'file_4_path',
      IFNULL(TRIM(file_5_type), '') AS 'file_5_type',
      IFNULL(TRIM(file_5_path), '') AS 'file_5_path',
      IFNULL(TRIM(file_6_type), '') AS 'file_6_type',
      IFNULL(TRIM(file_6_path), '') AS 'file_6_path',
      IFNULL(TRIM(file_7_type), '') AS 'file_7_type',
      IFNULL(TRIM(file_7_path), '') AS 'file_7_path',
      IFNULL(TRIM(file_8_type), '') AS 'file_8_type',
      IFNULL(TRIM(file_8_path), '') AS 'file_8_path',
      IFNULL(TRIM(file_9_type), '') AS 'file_9_type',
      IFNULL(TRIM(file_9_path), '') AS 'file_9_path',
      IFNULL(TRIM(file_10_type), '') AS 'file_10_type',
      IFNULL(TRIM(file_10_path), '') AS 'file_10_path'
      FROM payments.adhoc_invoice_details 
      WHERE purchase_order_number IS null 
      AND sbi_spoc_type IN (
        SELECT name FROM user_management_uat.department 
        WHERE department_id IN (${formatted})
      ) 
      AND entity_id = ${userCredentials.selectedentity} 
      AND is_active = 1;`
  };

  console.log('userCredentials["groups_id"],', userCredentials);
  var getProcessingLayerList = Fetchexecutequery();
  console.log("brs", getProcessingLayerList);

  axios.post(getProcessingLayerList[1], payload, getProcessingLayerList[0])
    .then(response => {
      console.log("Processing customer List vendor code!!!", response);

      let properData = response["data"];
      const purchaseOrdersList = properData.map((data) =>
        getFileDataRequired(data)
      );
      console.log("purchaseOrdersList", purchaseOrdersList);

      // Extract file paths along with IDs
      const files = [];
      purchaseOrdersList.forEach((fileData, idx) => {
        const rowId = properData[idx].id; // pick id from original row
        for (const key in fileData) {
          const fileEntry = fileData[key];
          if (fileEntry && typeof fileEntry === "object" && "path" in fileEntry) {
            files.push({
              id: rowId, // include id
              name: fileEntry.path.replace(/assets\/files\/(?:images|pdf)\//, ""),
              path: fileEntry.path
            });
          }
        }
      });

      console.log("options raw", files);

      const formattedOptions = files.map((file, index) => ({
        id: file.id,          // add id here
        label: file.name,     // dropdown display
        key: index,           // unique key
        value: file.path      // actual value
      }));

      console.log("options final", formattedOptions);
      setOptions(formattedOptions);
    })
    .catch(error => {
      console.log("Error in Processing Layer List!!!", error);
    });
}


    // Helper function to format date
  const getFormattedDate = () => {
    const currentDate = new Date();
    return currentDate.toISOString().slice(0, 19).replace("T", " ");
  };

  const enhanceRowsWithCommonFields = (rows, commonFields) =>
    rows.map(row => ({ ...row, ...commonFields }));

  // Helper function to create payload
  const createPayload = (database, table, formData) => ({
    database,
    table,
    formData,
  });

  // Helper function for Axios requests
  const makeApiRequest = (url, payload, headers) => {
    return axios.post(url, payload, headers)
      .then(response => {
        console.log("API Response:", response);
      })
      .catch(error => {
        console.error("API Error:", error);
        throw new Error("Error with API call");
      });
  };


  const fetchFieldInfo = async (headerConfigId, setFieldsFunc, setColumnDefsFunc) => {
    const payload = { headerconfig_id: headerConfigId,filterconditions: filterconditions };
  
    try {
      const FileUploadCredentials = Fetchheaderdata();
      const response = await axios.post(
        FileUploadCredentials[1], 
        payload, 
        FileUploadCredentials[0]
      );
  
      const data = response.data;
      console.log("fetched data",data)

      if (data.fields?.length) {
        const columns = data.fields.map((field) => ({
          headerName: formatColumnName(field.columnName),
          field: field.columnName,
        }));
  
        setColumnDefsFunc(columns);
        setFieldsFunc(data.fields);
        console.log("updation completed")
        return { fields: data.fields };
      }
    } catch (error) {
      console.error(`Error fetching field info for headerConfigId ${headerConfigId}:`, error);
      setError("Error fetching fields data");
        return { fields: []};
    }
  };
    

  const formatColumnName = (name) =>
    name.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());


const fetchprfTableInfo1 = async () => {
  const payload = { headerconfig_id: 65,filterconditions: filterconditions}; // 53 for old config
  try {
    const FileUploadCredentials = Fetchheaderdata(); // Function to fetch header data
    const response = await axios.post(
      FileUploadCredentials[1], // URL
      payload,                  // Payload
      FileUploadCredentials[0]  // Headers or Credentials
    );
    const data = response.data;
    console.log("header data",data);
    if (data.fields && data.fields.length > 0) {
      // Map the fields to columns
      const columns = data.fields.map((field) => ({
        headerName: formatColumnName(field.renameValue || field.columnName),
        field: field.columnName,
        sortable: true,
        filter: true,
        resizable: true,
        width: 185,
      }));
      // Define the "Select" column
      const selectColumn = {
        headerName: "",
        checkboxSelection: true,
        width: 50,
        pinned: "left", // Optional: pin the column to the left for better visibility
      };
      // Add the "Select" column as the first column
      columns.unshift(selectColumn);
      console.log("Table Column Definitions:", columns);
      settableColumnDefs(columns); // Update state with column definitions
    }
  } catch (error) {
    console.error("Error fetching field info:", error);
    setError("Error fetching fields data");
  } finally {
    setLoading(false); // Ensure loading state is updated even in case of an error
  }
};

  const onFilterTextChange = (event) => {
    const { value } = event.target;
    setSearchText(value);
  };

const fetchprfTableInfo2 = async () => {
  const payload = { headerconfig_id: 64,filterconditions: filterconditions};
  try {
    const FileUploadCredentials = Fetchheaderdata(); // Function to fetch header data
    const response = await axios.post(
      FileUploadCredentials[1], // URL
      payload,                  // Payload
      FileUploadCredentials[0]  // Headers or Credentials
    );
    const data = response.data;
    if (data.fields && data.fields.length > 0) {
      // Map the fields to columns
      const columns = data.fields.map((field) => ({
        headerName: formatColumnName(field.columnName),
        field: field.columnName,
        sortable: true,
        filter: true,
        resizable: true,
        width: 150,
      }));
      settableColumnDefs1(columns);
    }
  } catch (error) {
    console.error("Error fetching field info:", error);
    setError("Error fetching fields data");
  } finally {
    setLoading(false); // Ensure loading state is updated even in case of an error
  }
};

  const fetchtabledetailsInfo = async () => {
    const departmentid = userCredentials.department.join(",");
    const divisionid = userCredentials.division.join(",");

    const payload = { query: `SELECT
  po.id,
  IFNULL(TRIM(po.purchase_order_number), '') AS purchase_order_number,
  IFNULL(TRIM(po.vendor_name), '') AS vendor_name,
  IFNULL(TRIM(po.vendor_code), '') AS vendor_code,
  IFNULL(DATE_FORMAT(po.po_date, '%d-%m-%Y'), '') AS po_date,
  IFNULL(DATE_FORMAT(po.po_expiry_date, '%d-%m-%Y'), '') AS po_expiry_date,
  IFNULL(TRIM(po.po_purpose), '') AS po_purpose,
  IFNULL(TRIM(po.purchase_order_type), '') AS purchase_order_type,
  IFNULL(CONVERT(po.provision_cost, CHAR), '0.00') AS provision_cost,
  IFNULL(SUM(ai.invoice_amount), 0) AS approved_invoice_amount,
  (po.provision_cost - IFNULL(SUM(ai.invoice_amount), 0)) AS remaining_difference,
  (po.provision_cost - IFNULL(SUM(ai.invoice_amount), 0)) AS name,  IFNULL(TRIM(po.spoc_type), '') AS spoc_type

FROM payments.purchase_order po

LEFT JOIN payments.approved_invoices ai
  ON ai.purchase_order_number = po.purchase_order_number
  AND ai.is_approver_approved = 1
  AND ai.is_approver_rejected = 0
  AND ai.is_finance_rejected = 0
  AND ai.is_active = 1

WHERE
  po.entity_id = ${userCredentials.selectedentity}
  AND po.is_active = 1
  AND po.purchase_order_type IN (
    SELECT name
    FROM user_management_uat.divisions
    WHERE division_id IN (${divisionid})
  )
  AND po.spoc_type IN (
    SELECT name
    FROM user_management_uat.department
    WHERE department_id IN (${departmentid})
  )
GROUP BY
  po.id,
  po.purchase_order_number,
  po.vendor_name,
  po.vendor_code,
  po.po_date,
  po.po_expiry_date,
  po.po_purpose,
  po.purchase_order_type,
  po.provision_cost

HAVING remaining_difference > 0;
` };


    try {
      const FileUploadCredentials = Fetchexecutequery();
      const response = await axios.post(
        FileUploadCredentials[1],
        payload,
        FileUploadCredentials[0]
      );

      const data = response.data;
      if (data && data.length > 0) {
        const columns = Object.keys(data[0]).map((key) => ({
          headerName: formatColumnName(key),
          field: key,
        }));
	console.log("Table Row Data:", data);

        settableRowData(data);
      }
    } catch (error) {
      console.error("Error fetching department data:", error);
      setError("Error fetching department data");
    }
  };

  const fetchmilestonedetailsInfo = async (ponum) => {
    const payload = { query: `SELECT * FROM payments.payment_details where po_contract_number = '${ponum}'  AND entity_id = '${userCredentials.selectedentity}' AND is_active = 1 order by id;` };

    try {
      const FileUploadCredentials = Fetchexecutequery();
      const response = await axios.post(
        FileUploadCredentials[1],
        payload,
        FileUploadCredentials[0]
      );

      const data = response.data;
      if (data && data.length > 0) {
        const columns = Object.keys(data[0]).map((key) => ({
          headerName: formatColumnName(key),
          field: key,
        }));
	console.log("Table Row Data:", data);

        setRowData(data);
      }
    } catch (error) {
      console.error("Error fetching department data:", error);
      setError("Error fetching department data");
    }
  };

function formatToMySQLDate(dateStr) {
  // input: "14-08-2025"
  const [day, month, year] = dateStr.split("-");
  return `${year}-${month}-${day} 00:00:00`; // -> "2025-08-14 00:00:00"
}


const mappodata = async () => {
  console.log("Selected Row:", selectedRow, "Selected Value:", selectedvalue);

  if (!selectedRow) {
    console.warn("No row selected!");
    return;
  }

  try {
    // ---- 1. Fetch PO data ----
    const payload_1 = {
      query: `
        SELECT 
          IFNULL(TRIM(month), '') AS month,
          IFNULL(TRIM(purchase_order_number), '') AS purchase_order_number,
          id, po_date,
          IFNULL(DATE_FORMAT(po_expiry_date, '%d-%m-%Y'), '') AS po_expiry_date,
          IFNULL(TRIM(vendor_code), '') AS vendor_code,
          IFNULL(TRIM(vendor_name), '') AS vendor_name,
          IFNULL(TRIM(po_purpose), '') AS po_purpose,
          IFNULL(TRIM(delivery_location), '') AS delivery_location,
          IFNULL(TRIM(po_kind), '') AS po_kind,
          IFNULL(TRIM(expense_category), '') AS expense_category,
          IFNULL(TRIM(department_category), '') AS department_category,
          IFNULL(TRIM(sbu_head), '') AS sbu_head,
          IFNULL(TRIM(cost_code), '') AS cost_code,
          IFNULL(CONVERT(provision_cost, CHAR), '0.00') AS provision_cost,
          IFNULL(CONVERT(provision_amount, CHAR), '0.00') AS provision_amount,
          IFNULL(CONVERT(gst_amount, CHAR), '0.00') AS gst_amount,
          IFNULL(CONVERT(total_po_value, CHAR), '0.00') AS total_po_value,
          IFNULL(TRIM(po_requestor), '') AS po_requestor,
          IFNULL(TRIM(po_type), '') AS po_type,
          IFNULL(TRIM(prepared_by), '') AS prepared_by,
          IFNULL(TRIM(cross_checked_by), '') AS cross_checked_by,
          is_purchase_order,
          IFNULL(TRIM(po_status_approved_by), '') AS po_status_approved_by,
          IFNULL(TRIM(payment_terms), '') AS payment_terms,
          IFNULL(TRIM(delivery_period), '') AS delivery_period,
          IFNULL(TRIM(invoice_number), '') AS invoice_number,
          IFNULL(CONVERT(invoice_amount, CHAR), '0.00') AS invoice_amount,
          IFNULL(CONVERT(difference_amount, CHAR), '') AS difference_amount,
          IFNULL(TRIM(status), '') AS status,
          IFNULL(TRIM(ap_module_ibn), '') AS ap_module_ibn,
          IFNULL(TRIM(budgeted_or_not_budgeted), '') AS budgeted_or_not_budgeted,
          IFNULL(TRIM(spoc_type), '') AS spoc_type, IFNULL(TRIM(purchase_order_type), '') AS purchase_order_type
        FROM payments.purchase_order 
        WHERE id = ${Number(selectedRow.id)};
      `
    };

    const FileUploadCredentials_1 = Fetchexecutequery();
    const response_1 = await axios.post(FileUploadCredentials_1[1], payload_1, FileUploadCredentials_1[0]);
    const poData = response_1.data?.[0] || {};

    console.log("PO Data:", poData);

    // ---- 2. Build formData ----
    const formattedDate = getFormattedDate();
    const newFormData = {
      month: poData.month || "",
      purchase_order_number: poData.purchase_order_number || "",
      po_date: poData.po_date || null,
      vendor_code: poData.vendor_code || "",
      vendor_name: poData.vendor_name || "",
      po_purpose: poData.po_purpose || "",
      delivery_location: poData.delivery_location || "",
      expense_category: poData.expense_category || "",
      department_category: poData.department_category || "",
      sbu_head: poData.sbu_head || "",
      cost_code: poData.cost_code || "",
      provision_cost: poData.provision_cost || "",
      provision_amount: poData.provision_amount || "",
      gst_amount: poData.gst_amount || "",
      total_po_value: poData.total_po_value || "",
      po_requestor: poData.po_requestor || "",
      po_type: poData.po_type || "",
      prepared_by: poData.prepared_by || "",
      cross_checked_by: poData.cross_checked_by || "",
      po_status_approved_by: poData.po_status_approved_by || "",
      payment_terms: poData.payment_terms || "",
      delivery_period: poData.delivery_period || "",
      invoice_number: "",
      ap_module_ibn: "",
      budgeted_or_not_budgeted: poData.budgeted_or_not_budgeted || "",
      po_kind: poData.po_kind || "",
      is_purchase_order: poData.is_purchase_order,
      adhoc_invoice_details_id: selectedvalue.id || "",
      purchase_order_id: poData.id || "",
      purchase_order_type: poData.purchase_order_type || "",
      spoc_type: poData.spoc_type || "",
      entity_id: userCredentials.selectedentity || "",
      last_updated_by: userCredentials.user_name,
      created_on: formattedDate,
      last_updated_on: formattedDate
    };

    console.log("Form Data ready:", newFormData);

    // ---- 3. Insert mapped data ----
    const FileUploadCredentials_2 = CreateData();
    await axios.post(FileUploadCredentials_2[1], { database: "payments", table: "purchase_order_mapped", formData: newFormData }, FileUploadCredentials_2[0]);
    console.log("Mapped data inserted");

    const payload_invoice = {
      schema_name: "payments",
      table: "adhoc_invoice_details",
      set_column: [{ purchase_order_number: poData.purchase_order_number }],
      where: [{ id: selectedvalue.id }]
    };

    const FileUploadCredentials_3 = Fetchupdatequery();
    await axios.post(FileUploadCredentials_3[1], payload_invoice, FileUploadCredentials_3[0]);
    console.log("adhoc_invoice_details updated");

    // ---- 5. Reset selection ----
    if (gridApi) gridApi.deselectAll();
    setSelectedRow(null);
    setSelectedvalue(null);
    setSelectedFile('');
    setFileType('');

    // ---- 6. Refresh dropdown and table AFTER all DB operations ----
    await BrsTypeList();
    await fetchtabledetailsInfo();
    console.log("Dropdown and table refreshed");

  } catch (error) {
    console.error("Error in mapping process:", error);
    setError("Error in mapping process");
  }
};

  const handleInputChange = (name, value) => {
    console.log("formdata",formData)
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleInputChange3_1 = (name, value, index) => {
    setSection3Rows(prevRows => {
      const updatedRows = [...prevRows];
      updatedRows[index] = {
        ...updatedRows[index],
        [name]: value,
      };
      return updatedRows;
    });
  };

  const validateField = (value, type) => {
      if (!type) return true; // If no type is defined, skip validation

      switch (type.value) {
          case "text":
              return true; // Allow any text input
          case "integer":
              return /^-?\d*$/.test(value); // Allow integers (positive or negative) and empty input for partial typing
          case "decimal":
              return /^-?\d*\.?\d*$/.test(value); // Allow numbers with optional decimal points
          case "date":
              return !isNaN(Date.parse(value)); // Validate as a valid date
          default:
              return true; // For unsupported types, skip validation
      }
  };


  const handleInputChange1 = (name, value, index,type) => {
    console.log("section2rows",section2Rows)
    setSection2Rows(prevRows => {
      const updatedRows = [...prevRows];
      const isValid = validateField(value, type);
      if (!isValid) {
        console.warn(`Invalid input for ${type?.label}: ${value}`);
        return prevRows; // If invalid, do not update the state
      }
      // Update the field with the new value
      updatedRows[index] = {
        ...updatedRows[index],
        [name]: value,
      };
      // If the updated field is 'quantity' or 'unit_value', recalculate 'total_value'
      if (name === "quantity" || name === "unit_value") {
        const updatedRow = updatedRows[index];
        const totalValue = updatedRow.quantity * updatedRow.unit_value;
        // Update the total_value in the row
        updatedRows[index] = {
          ...updatedRow,
          total_value: totalValue,  // Recalculate total_value
        };
      }
      // Return the updated rows after modifying the necessary fields
      return updatedRows;
    });
  };



  const handlequotatationInputChange3 = (name, value, index,type) => {
    // First, update section3Rows
    console.log(section3Rows,index,quotationinputData)
    setSection3Rows(prevRows => {
      const updatedRows = [...prevRows];
      if (!Number.isInteger(index) || index < 0 || index >= updatedRows.length) {
        console.warn(`Invalid row index: ${index}. Defaulting to 0.`);
        index = 0; // Default index to 0 if invalid
      }

      const isValid = validateField(value, type);
      if (!isValid) {
        console.warn(`Invalid input for ${type?.label}: ${value}`);
        return prevRows; // If invalid, do not update the state
      }
      updatedRows[index] = {
        ...updatedRows[index],
        [name]: value,
      };
      // If the 'quantity' or 'unit_value' changed, recalculate total_value
      if (name === "quantity" || name === "unit_value") {
        const updatedRow = updatedRows[index];
        const totalValue = updatedRow.quantity * updatedRow.unit_value;
        // Update the total_value in the row
        updatedRows[index] = {
          ...updatedRow,
          total_value: totalValue,  // Recalculate total_value
        };
      }
      return updatedRows;
    });
    // Then, update quotationinputData
    setQuotationinputData(prevQuotationData => {
      const updatedQuotationData = [...prevQuotationData];

      // Initialize section3Rows for the selectedQuotationId if it doesn't exist
      if (!updatedQuotationData[selectedQuotationId]) {
        updatedQuotationData[selectedQuotationId] = [];
      }

      // Ensure the row exists in quotationData for the current index
      if (!updatedQuotationData[selectedQuotationId][index]) {
        updatedQuotationData[selectedQuotationId][index] = {};
      }


      // Update the specific field in quotationData
      updatedQuotationData[selectedQuotationId][index][name] = value;

      // If the 'quantity' or 'unit_value' changed, recalculate total_value
      if (name === "quantity" || name === "unit_value") {
        const updatedRow = updatedQuotationData[selectedQuotationId][index];
        const totalValue = updatedRow.quantity * updatedRow.unit_value;

        // Update the total_value in the row for quotationData
        updatedQuotationData[selectedQuotationId][index] = {
          ...updatedRow,
          total_value: totalValue,  // Recalculate total_value
        };
      }

      return updatedQuotationData;
    });
  };

const onSelectionChanged = (event) => {
  const selectedRows = event.api.getSelectedRows();
  console.log("selectedRows", selectedRows);

  if (selectedRows && selectedRows.length > 0) {
    const selectedRow = selectedRows[0];
    setSelectedRow(selectedRow);

    const poNumber = selectedRow.purchase_order_number || "";
    fetchmilestonedetailsInfo(poNumber);
  } else {
    setSelectedRow(null);
    fetchmilestonedetailsInfo(""); // or skip fetching if nothing selected
  }
};


  const handleQuotationChange = (name, value) => {
    setFormData2((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    // Update quotationData with the current quotation's edited data
    setQuotationData((prevData) => ({
      ...prevData,
      [selectedQuotationId]: {
        ...prevData[selectedQuotationId],
        [name]: value,
      },
    }));
    console.log("Updated field:",quotations, name, "with value:", value,quotationinputData);
  };

  const handleInputChange3 = (name, value) => {
    setFormData3((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };


  // Toggle div visibility
  const toggleDiv1 = () => setIsDiv1Open(!isDiv1Open);
  const toggleDiv2 = () => setIsDiv2Open(!isDiv2Open);
  const toggleDiv3 = () => setIsDiv3Open(!isDiv3Open);
  const toggleDiv4 = () => setIsDiv4Open(!isDiv4Open);

  if (loading) return <LoaderComponent />;

  return (
<div>
    <div>
      <h2 className="pt-1 pb-1 text-center" style={{ color: "#0a2352", fontSize: '18px' }}>
        PO MAPPING
      </h2>
    </div>

{showDetails && (
  <div
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(0,0,0,0.5)", // dark overlay
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 9999,
    }}
  >
    <div
      style={{
        background: "white",
        padding: "20px",
        borderRadius: "8px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
        width: "80%",
        maxWidth: "1000px",
      }}
    >
      {/* Close Button */}
      <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "10px" }}>
        <button
          onClick={() => setShowDetails(false)}
          style={{
            padding: "8px 15px",
            backgroundColor: "#cc0000",
            color: "white",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
          }}
        >
          ? Close
        </button>
      </div>

      {/* AG Grid Table */}
      <div
        className="ag-theme-alpine"
        style={{ height: 400, width: "100%" }}
      >
        <AgGridReact
          rowData={rowData}
          columnDefs={tablecolumnDefs1}
          pagination
        />
      </div>
    </div>
  </div>
)}

      <Grid columns='equal' divided style={{ paddingLeft: "10px", borderRadius: "15px", margin: '0em', marginTop: '-3.3em' }} className="mt-2 mb-2">
        <Grid.Row divided style={{ paddingLeft: "10px", paddingTop: "30px"}}>
          <Grid.Column >
<div
  style={{
    display: "flex",
    alignItems: "center",
    gap: "12px",
    width: "100%",
  }}
>
  {/* Dropdown � fluid width */}
  <div style={{ flex: 1 }}>
    <Select
      selection
      options={options}
      size="mini"
      style={{ backgroundColor: "white", width: "100%" }}
      value={selectedvalue}
      onChange={handleSelection}
    />
  </div>

  {/* Delete button � red, fixed width */}
  {selectedvalue && (
    <button
      type="button"
      onClick={deleteAttachments}
      style={{
        backgroundColor: "#d32f2f",   // red
        color: "#ffffff",
        border: "none",
        padding: "6px 14px",
        borderRadius: "4px",
        cursor: "pointer",
        whiteSpace: "nowrap",
      }}
    >
      Delete
    </button>
  )}
</div>
<div style={{ marginTop: '20px', overflow: "auto",textAlign: 'center' }}>
        {fileType === 'pdf' && (
<FilePreviewer
  fileType="pdf"
  fileUrl={`http://206.1.17.185:1200/api/v2/user_modules/serve-pdf/${selectedvalue.label}`}
/>
)}
        {fileType === 'image' && (
          <img
            src={`${baseUrl}/${selectedFile}`}
            alt="Selected file preview"
            style={{ maxWidth: '100%', maxHeight: '600px' }}
          />
        )}
        {!fileType && selectedFile && (
          <h3 style={{ color: 'red' }}>Unsupported file type</h3>
        )}
        {!selectedFile && (
          <h3>Choose a File to Preview</h3>
        )}
      </div> 
         </Grid.Column >
          <Grid.Column >
<div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', marginBottom: '10px' }}>
  {gridApi && (
    <div style={{ flex: '0 0 auto', width: '300px' }}>
      <SearchInput onInputChange={handleGridSearch} />
    </div>
  )}
</div>
        <div
          className="ag-theme-alpine"
          style={{
            overflowX: 'auto',
            overflowY: 'auto',
            borderRadius: '10px',
            width: `${ 6* 200}px`,
            maxWidth: '100%',
            height: '510px',
            paddingTop:'10px'
            
          }}
        >

          <AgGridReact
            columnDefs={tablecolumnDefs}
            rowData={tablerowData}
            animateRows={true}
            pagination={true}
            paginationPageSize={10}
            rowSelection="single" // or "multiple" for multi-row selection
            onSelectionChanged={onSelectionChanged}
            onGridReady={(params) => setGridApi(params.api)} 
          />
</div>
<div style = {{display : "flex"}}>
      <div className="submit-row">
        <button type="submit" className="submit-btn" onClick={handleDetailsClick}>Details</button>
      </div>
      <div className="submit-row">
        <button type="submit" className="submit-btn" onClick={mappodata} >Map PO</button>
      </div>
      </div>
          </Grid.Column >
        </Grid.Row >
        </Grid>
</div>
  );
}

export default PurchaseRequirement;